import gql from "graphql-tag";

export const MUTATION_LOGIN = gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      token
      user {
        email
        company
        role
        report_number_prefix
        restrict_access
      }
    }
  }
`;
